import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import qs from "qs";
import { isEmpty, omitBy } from "lib";
import { Tooltip } from "views/components";
import PadlockIcon from "views/components/icons/PadlockIcon";
import style from "./style.module.css";

const removeKeys = (obj, keysToOmit) => {
  const objWithoutEmptyKeys = omitBy(obj, isEmpty);
  keysToOmit.forEach(key => delete objWithoutEmptyKeys[key]);
  return objWithoutEmptyKeys;
};

const QueryLink = ({
  pathname,
  query,
  keysToOmit = [],
  children,
  isLocked,
  tipText = "this option is currently disabled",
  ...props
}) => {
  const search = qs.stringify(removeKeys(query, keysToOmit));

  return (
    <NavLink
      {...props}
      to={
        !isLocked
          ? {
              pathname,
              search
            }
          : "#"
      }
      className={isLocked ? style.linkDisabled : props.className}
    >
      <div
        className={style.contents}
        data-tip={isLocked ? tipText : null}
        data-for={isLocked ? style.lockedTabTip : null}
      >
        {isLocked && (
          <div className={style.padLock}>
            <PadlockIcon
              noKeyhole
              color="var(--color-easil-gray-x-dark)"
              size="16px"
            />
          </div>
        )}
        {children}
        {isLocked && <Tooltip id={style.lockedTabTip} place="bottom" />}
      </div>
    </NavLink>
  );
};

QueryLink.propTypes = {
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object,
  keysToOmit: PropTypes.array
};

export default QueryLink;
